import type { useLatestOrderAnalytics } from '@src/hooks/useLatestOrderAnalytics';
import { Card, EmptyView, Flex, LoaderTalos, type CardProps, type Order } from '@talos/kyoko';
import { useTheme } from 'styled-components';
import { IWouldCardContent } from './IWouldCardContent';

export function IWouldCard({
  order,
  isMultileg,
  analytics,
  ...props
}: { order: Order; isMultileg?: boolean; analytics: ReturnType<typeof useLatestOrderAnalytics> } & CardProps) {
  const { latestAnalytics, receivedAnalytics } = analytics;
  const { spacing48 } = useTheme();

  if (latestAnalytics == null) {
    return (
      <Card title="I Would Analytics" {...props}>
        <Flex justifyContent="center" alignItems="center" minHeight={spacing48 * (isMultileg ? 4 : 2)}>
          {receivedAnalytics ? <EmptyView>No I Would analytics available</EmptyView> : <LoaderTalos />}
        </Flex>
      </Card>
    );
  }

  return (
    <Card title="I Would Analytics" {...props}>
      {isMultileg ? (
        <div>
          <IWouldCardContent order={order} leg={1} latestAnalytics={latestAnalytics} />
          <IWouldCardContent order={order} leg={2} latestAnalytics={latestAnalytics} />
        </div>
      ) : (
        <IWouldCardContent order={order} latestAnalytics={latestAnalytics} />
      )}
    </Card>
  );
}
